import React from 'react';

interface ArrowUpProps {
    fill?: string;
}

export const ArrowUp = ({ fill = 'currentColor' }: ArrowUpProps) => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_10_194)">
            <path
                d="M7.5 14L8.5 14L8.4845 3.27749L10.6465 5.43849L11.3535 4.73149L9.0605 2.43849C8.77921 2.15729 8.39775 1.99931 8 1.99931C7.60225 1.99931 7.22079 2.15729 6.9395 2.43849L4.6465 4.73149L5.3535 5.43849L7.4845 3.30749L7.5 14Z"
                fill={fill}
            />
        </g>
        <defs>
            <clipPath id="clip0_10_194">
                <rect width="12" height="12" fill="white" transform="translate(14 2) rotate(90)" />
            </clipPath>
        </defs>
    </svg>
);
